var site = site || {};
site.Utilities = (function () {
    // Functions

    const loadWidgetScripts = () => {
        let scriptsToLoad = [];
        const jsWidget = document.querySelectorAll('[data-scripts]');
        jsWidget.forEach((widget) => {
            const widgetScripts = widget.getAttribute('data-scripts');
            let widgetScriptsArray = widgetScripts.split(",");
            widgetScriptsArray.forEach((src) => {
                let scriptSrcTrimmed = src.trim();
                if (!scriptsToLoad.indexOf(scriptSrcTrimmed) != -1) {
                    scriptsToLoad.push(scriptSrcTrimmed);
                }
            });
        });
        scriptsToLoad.forEach(function (index, value) {
            setTimeout(function () {
                let newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.src = index;
                // newScript.defer = true;
                document.getElementsByTagName('body')[0].appendChild(newScript);
            }, 250 * value);
        });
    }   
    
    const setLeftOffset = () => {
        const offsetElement = document.querySelector('.js-left-offset');
        if (offsetElement) {
            const containerOffsetLeft = document.querySelector('.container').offsetLeft + 12 + "px";
            offsetElement.style.marginLeft = containerOffsetLeft;
        }
    }

    // Return
    return {
        loadWidgetScripts : loadWidgetScripts,
        setLeftOffset : setLeftOffset
    };
}());